function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_105",
  "data-name": "Rectangle 105",
  width: 26,
  height: 26,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Exclusion_16",
  "data-name": "Exclusion 16",
  d: "M26.3-8059.857h0l-4.943-4.943a6.912,6.912,0,0,1-4.441,1.62,6.917,6.917,0,0,1-6.91-6.908A6.918,6.918,0,0,1,16.91-8077a6.918,6.918,0,0,1,6.91,6.911,6.9,6.9,0,0,1-1.751,4.591L27-8060.564l-.707.707ZM16.91-8076A5.917,5.917,0,0,0,11-8070.089a5.916,5.916,0,0,0,5.909,5.909,5.916,5.916,0,0,0,5.909-5.909A5.917,5.917,0,0,0,16.91-8076Z",
  transform: "translate(-5.751 8081.168)"
});

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_search_-_outlined",
    "data-name": "icon - search - outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.e9c58c21.svg";
export { ForwardRef as ReactComponent };